import React from 'react';
import { ShieldAlert } from 'lucide-react';
import { SidebarMenuItem, SidebarMenuButton } from 'src/shared/components/ui/sidebar';
import { useAppSelector } from 'src/store';
import { getAppRoutesAvailability, getPortfolioRoutesAvailability } from 'src/routes/state/routesSelector';
import { useLocation } from 'react-router-dom';
import useAppNavigation from 'src/shared/hooks/useAppNavigation';
import NestedSidebarMenuItem from './NestedSidebarMenuItem';

type GlobalNatureRiskMenuProps = {
    readonly riskInsightsEnabled: boolean;
};

const GlobalNatureRiskMenu = ({ riskInsightsEnabled }: GlobalNatureRiskMenuProps) => {
    const appRoutesAvailability = useAppSelector(getAppRoutesAvailability);
    const portfolioRoutesAvailability = useAppSelector(getPortfolioRoutesAvailability);
    const navigate = useAppNavigation();
    const { pathname } = useLocation();

    if (!appRoutesAvailability.portfolio || !portfolioRoutesAvailability.globalNatureRiskSiteList) {
        return null;
    }

    const isGlobalNatureRiskActive = pathname.includes('/portfolio/global-nature-risk');
    const subItems = [
        {
            title: 'Overview',
            testId: 'global-nature-risk-overview-menu-item',
            onClick: () => navigate.toGlobalNatureRiskOverview(),
            isActive: pathname.includes('/portfolio/global-nature-risk/overview'),
        },
        {
            title: 'State of Nature',
            testId: 'global-nature-risk-state-of-nature-menu-item',
            onClick: () => navigate.toGlobalNatureRiskStateOfNature(),
            isActive: pathname.includes('/portfolio/global-nature-risk/state-of-nature'),
        },
        {
            title: 'Impacts & Dependencies',
            testId: 'global-nature-risk-impacts-and-dependencies-menu-item',
            onClick: () => navigate.toGlobalNatureRiskImpactsAndDependencies(),
            isActive: pathname.includes('/portfolio/global-nature-risk/impacts-and-dependencies'),
        },
        {
            title: 'Site List',
            testId: 'global-nature-risk-site-list-menu-item',
            onClick: () => navigate.toGlobalNatureRiskSiteList(),
            isActive: pathname.includes('/site-list'),
        },
    ];

    if (!riskInsightsEnabled) {
        return (
            <SidebarMenuItem>
                <SidebarMenuButton
                    tooltip='Global Nature Risk'
                    isActive={isGlobalNatureRiskActive}
                    onClick={() => navigate.toGlobalNatureRiskOverview()}
                    data-testid='global-nature-risk-menu-button'
                >
                    <ShieldAlert />
                    <span>Global Nature Risk</span>
                </SidebarMenuButton>
            </SidebarMenuItem>
        );
    }

    return (
        <NestedSidebarMenuItem
            label='Global Nature Risk'
            testId='global-nature-risk-menu-button'
            icon={<ShieldAlert />}
            isActive={isGlobalNatureRiskActive}
            defaultOpen={isGlobalNatureRiskActive}
            subItems={subItems}
        />
    );
};

export default GlobalNatureRiskMenu;
